var map = {
	"./18.jpg": "d4c8",
	"./26.jpg": "df4a",
	"./27.jpg": "c0a3",
	"./28.jpg": "b1ae",
	"./29.jpg": "973c",
	"./30.jpg": "0f3c",
	"./31.jpg": "5f4f",
	"./32.jpg": "2729",
	"./33.jpg": "2fe6",
	"./34.jpg": "9f5a",
	"./35.jpg": "c024",
	"./36.jpg": "b98c",
	"./37.jpg": "b2c2",
	"./38.jpg": "92e7",
	"./39.jpg": "05ea",
	"./42.jpg": "e18a",
	"./dowjonespecial.jpg": "6741",
	"./hanoisupervip.png": "706e",
	"./investing.png": "3079",
	"./laosdc.png": "0f4b",
	"./laosinter.png": "527a",
	"./thaivip.png": "0ad1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1a6";